export default "__VITE_ASSET__VrS58b0s__"